import { Component, Input } from '@angular/core';
import { FormBuilderSectionModel } from '../../models/form-builder-section-model';

@Component({
  selector: 'tf-core-fb-preview-header',
  templateUrl: './fb-preview-header.component.html',
  styleUrls: ['./fb-preview-header.component.css']
})
export class FbCorePreviewHeaderComponent {
    @Input()
    title: string;

    @Input()
    sections: FormBuilderSectionModel[];

    @Input()
    selectedSection: string;

    public getSelectedSectionLabel(): string {
        const selectedIndex = this.sections.findIndex(x => x.label === this.selectedSection);

        return this.sections[selectedIndex].components[0].label;
    }
}
